// Mock 数据文件 - 涂装车间用能数据概览

// 能源统计
export const energyStats = {
  totalCost: 289.1, // 能源总成本（万元）
  plannedCost: 289.1, // 计划成本（万元）
  completionRate: 48.53, // 完成率 %
};

// 能源成本表格
export const energyCostTable = [
  { type: '电', actualCost: 28924.8, plannedCost: 28924.8, completionRate: 12.9, color: '#2D8DFF' },
  { type: '天然气', actualCost: 36985.3, plannedCost: 36985.3, completionRate: 12.9, color: '#FFCB47' },
  { type: '压缩空气', actualCost: 28924.1, plannedCost: 28924.1, completionRate: 12.9, color: '#16DD8E' },
];

// 设备类型用能占比（饼图）
export const deviceTypeEnergyRatio = {
  total: 128560,
  unit: 'kWh',
  items: [
    { name: '除湿机', value: 128560 * 0.24, rate: 24, cost: '1325.1kWh', color: '#2D8DFF' },
    { name: 'VOCS设备', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#FF477B' },
    { name: '除尘机', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#FFCB47' },
    { name: '吸砂机', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#9B59B6' },
    { name: '喷砂机', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#16DD8E' },
    { name: '磨料回砂系统', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#52E7FF' },
  ],
  highest: { name: '除湿机', ratio: 45.3, value: '148.9万kWh' },
  lowest: { name: '磨料回砂系统', ratio: 3.1, value: '10.1万kWh' },
};

// 用能趋势（折线图）
export const energyTrend = {
  title: '用能趋势',
  data: generateTrendData(),
};

// 总能耗数据
export const totalEnergyData = {
  electricity: { value: 289.1, unit: '万', factoryRatio: 26.2 },
  compressedAir: { value: 289.1, unit: '万', factoryRatio: 26.2 },
  naturalGas: { value: 289.1, unit: '万', factoryRatio: 26.2 },
};

// 涂装车间统计 - 各期用电成本
export const workshopStats = {
  phases: [
    {
      name: '涂装一期',
      cost: 286.32,
      electricity: 28924.8,
      compressedAir: 28924.8,
      naturalGas: 28924.8,
      electricityPlan: 28924.8,
      compressedAirPlan: 28924.8,
      naturalGasPlan: 28924.8,
      electricityRate: 23.1,
      compressedAirRate: 23.1,
      naturalGasRate: 23.1,
    },
    {
      name: '涂装二期',
      cost: 286.32,
      electricity: 28924.8,
      compressedAir: 28924.8,
      naturalGas: 28924.8,
      electricityPlan: 28924.8,
      compressedAirPlan: 28924.8,
      naturalGasPlan: 28924.8,
      electricityRate: 23.1,
      compressedAirRate: 23.1,
      naturalGasRate: 23.1,
    },
    {
      name: '涂装三期',
      cost: 286.32,
      electricity: 28924.8,
      compressedAir: 28924.8,
      naturalGas: 28924.8,
      electricityPlan: 28924.8,
      compressedAirPlan: 28924.8,
      naturalGasPlan: 28924.8,
      electricityRate: 23.1,
      compressedAirRate: 23.1,
      naturalGasRate: 23.1,
    },
  ],
};

// 车间详情弹窗 - 跨间数据
const spanNames = ['A跨', 'B跨', 'C跨', 'D跨', 'E跨', 'F跨'];
export const workshopSpanData = spanNames.map(name => ({
  name,
  electricity: 148924.8,
  compressedAir: 9236.5,
  naturalGas: 6682.2,
  cost: 28924.8,
}));

// 车间详情弹窗 - 汇总数据
export const workshopDetailSummary = {
  electricity: { value: 27.6, plan: 26421, rate: 96.3 },
  compressedAir: { value: 27.6, plan: 26421, rate: 96.3 },
  naturalGas: { value: 27.6, plan: 26421, rate: 96.3 },
  cost: { value: 9526, plan: 26421, rate: 96.3 },
};

// 车间详情弹窗 - 用能趋势数据
export const workshopTrendData = (() => {
  const data: { date: string; electricity: number; compressedAir: number; naturalGas: number }[] = [];
  const now = new Date(2025, 4, 31);
  for (let i = 30; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    data.push({
      date: `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
      electricity: Math.round(4000 + Math.random() * 2000),
      compressedAir: Math.round(3000 + Math.random() * 1500),
      naturalGas: Math.round(2000 + Math.random() * 1000),
    });
  }
  return data;
})();

// 车间详情弹窗 - 成本明细
export const workshopCostBreakdown = [
  { name: '用电成本', value: 62350, ratio: 65.4, color: '#52E7FF' },
  { name: '天然气成本', value: 62350, ratio: 15.4, color: '#FFCB47' },
  { name: '压缩空气成本', value: 62350, ratio: 19.2, color: '#2D8DFF' },
];

// 设备能耗 - 高能耗设备
export const highEnergyDevice = {
  electricityUsage: 289.1, // 高能耗设备用电量（万kWh）
  ratio: 48.53, // 占涂装总用电量 %
};

// 高能耗设备类型用能占比（饼图）
export const highEnergyDeviceRatio = {
  items: [
    { name: '除湿机', value: 128560 * 0.24, rate: 24, cost: '1325.1kWh', color: '#2D8DFF' },
    { name: 'VOCS设备', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#FF477B' },
    { name: '除尘机', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#FFCB47' },
    { name: '吸砂机', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#9B59B6' },
    { name: '喷砂机', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#16DD8E' },
    { name: '磨料回砂系统', value: 128560 * 0.15, rate: 15, cost: '1325.1kWh', color: '#52E7FF' },
  ],
  highest: { name: '除湿机', ratio: 45.3, value: '148.9万kWh' },
  lowest: { name: '磨料回砂系统', ratio: 3.1, value: '10.1万kWh' },
};

// 高能耗设备用电趋势（柱状图 + 折线图）
export const highEnergyTrend = {
  title: '高能耗设备用电趋势',
  data: generateTrendData(),
};

// 除湿机&VOCS详细数据
export const deviceDetail = {
  dehumidifier: {
    name: '除湿机',
    count: 16,
    electricityUsage: 289.1,
    ratio: 23.6,
  },
  vocs: {
    name: 'VOCS',
    count: 5,
    electricityUsage: 2654.3,
    ratio: 23.6,
  },
};

// 辅助函数：生成趋势数据（柱状 + 折线）
function generateTrendData() {
  const data = [];
  const now = new Date(2025, 4, 31);
  for (let i = 30; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    const flowValue = 3000 + Math.random() * 2500;
    const pressureValue = 3000 + Math.random() * 2000;
    data.push({
      date: `${date.getMonth() + 1}/${date.getDate()}`,
      flow: Math.round(flowValue),
      pressure: Math.round(pressureValue),
    });
  }
  return data;
}

function generatePhaseTrendData(baseValue: number) {
  const data: { date: string; value: number }[] = [];
  const now = new Date(2025, 4, 31);
  for (let i = 30; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    data.push({
      date: `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
      value: Math.round(baseValue + (Math.random() - 0.5) * baseValue * 0.6),
    });
  }
  return data;
}

// 除湿机弹窗 - 分车间数据
export const dehumidifierPhases = [
  {
    name: '涂装一期',
    count: 6,
    electricityUsage: 156.2,
    ratio: 54.6,
    phaseRatio: 45.3,
    trendData: generatePhaseTrendData(5000),
  },
  {
    name: '涂装二期',
    count: 5,
    electricityUsage: 78.1,
    ratio: 27.0,
    phaseRatio: 30.1,
    trendData: generatePhaseTrendData(3000),
  },
  {
    name: '涂装三期',
    count: 5,
    electricityUsage: 54.8,
    ratio: 18.3,
    phaseRatio: 24.6,
    trendData: generatePhaseTrendData(2500),
  },
];

function generateDualTrendData(elecBase: number, gasBase: number) {
  const data: { date: string; electricity: number; gas: number }[] = [];
  const now = new Date(2025, 4, 31);
  for (let i = 30; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    data.push({
      date: `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
      electricity: Math.round(elecBase + (Math.random() - 0.5) * elecBase * 0.6),
      gas: Math.round(gasBase + (Math.random() - 0.5) * gasBase * 0.5),
    });
  }
  return data;
}

// VOCs 弹窗 - 分车间数据
export const vocsPhases = [
  {
    name: '涂装一期',
    electricityUsage: 156.2,
    ratio: 54.6,
    phaseRatio: 75.2,
    gasUsage: 289.1,
    gasRatio: 54.6,
    trendData: generateDualTrendData(5000, 3000),
  },
  {
    name: '涂装二期',
    electricityUsage: 78.1,
    ratio: 27.0,
    phaseRatio: 75.2,
    gasUsage: 289.1,
    gasRatio: 54.6,
    trendData: generateDualTrendData(3000, 2000),
  },
  {
    name: '涂装三期',
    electricityUsage: 54.8,
    ratio: 18.3,
    phaseRatio: 75.2,
    gasUsage: 289.1,
    gasRatio: 54.6,
    trendData: generateDualTrendData(2500, 1800),
  },
];

// VOCs 汇总数据
export const vocsSummary = {
  name: 'VOCS',
  count: 3,
  electricityUsage: 289.1,
  electricityRatio: 54.6,
  gasUsage: 289.1,
};

export default {
  energyStats,
  energyCostTable,
  deviceTypeEnergyRatio,
  energyTrend,
  totalEnergyData,
  workshopStats,
  highEnergyDevice,
  highEnergyDeviceRatio,
  highEnergyTrend,
  deviceDetail,
  dehumidifierPhases,
  vocsPhases,
  vocsSummary,
  workshopSpanData,
  workshopDetailSummary,
  workshopTrendData,
  workshopCostBreakdown,
};
